
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "Panel",
  props: {
    header: String,
    optional: Boolean,
    modelValue: Boolean,
    closed: Boolean
  },
  setup(props) {
    const checked = ref(props.modelValue);
    const open = ref(props.closed ? false : true);

    const handleOpen = (event: { target: HTMLElement }) => {
      if (event.target.tagName === "INPUT") return;
      open.value = !open.value;
    };

    return { checked, open, handleOpen };
  }
});
